import adminAxios from "@/shared/api/adminAxiosInstance";

export const getUsers = (params) => {
    return adminAxios.get('/admin/users', {params});
};
export const updateBlockUser = (id) => {
    return adminAxios.put(`/admin/users/${id}/block`);
}

export const updateWritePoints = (id) => {
    return adminAxios.put(`/admin/users/${id}/write-points`);
}

